export default "__VITE_ASSET__DwQtWCo5__"